import React, { forwardRef } from "react";
import { InlineButton } from "../InlineButton/InlineButton";
import clsx from "clsx";
export interface GoBackButtonProps {
  label: string;
  size?: 'default' | 'small' | 'medium';
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLElement>) => void;
  autoTestId?: string;
  ariaLabel?: string;
  ariaExpanded?: boolean;
  autoFocus?: boolean;
  tabIndex?: number;
  testId?: string;
}

const GoBackButton = forwardRef<HTMLButtonElement | null, GoBackButtonProps>(
  (
    {
      size = 'default',
      className,
      label,
      disabled,
      onClick,
      onKeyDown,
      autoTestId,
      ariaLabel,
      ariaExpanded = false,
      autoFocus = false,
      tabIndex = 0,
      testId,
    },
    ref,
  ) => {
    return (
      <InlineButton
        iconType="chevronLeft"
        iconPlacement="left"
        className={clsx(className, 'GoBackButton')}
        onClick={onClick}
        disabled={disabled}
        ref={ref}
        onKeyDown={onKeyDown}
        autoTestId={autoTestId}
        ariaLabel={ariaLabel}
        ariaExpanded={ariaExpanded}
        autoFocus={autoFocus}
        tabIndex={tabIndex}
        testId={testId}
        size={size}
      >
        {label}
      </InlineButton>
    );
  },
);

GoBackButton.displayName = "GoBackButton";

export default GoBackButton;
